// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import styles from './ContactSection.module.scss';
import ControlPanelBackground from './control-panel-background.svg';

const ContactSection: PageComponent = () => {
    // TODO: check responsive
    return (
        <section className={styles.section}>
            <h1>
                <Trans
                    i18nKey="contact.title"
                    ns="landingInformationAboutCompany"
                >
                    Kontaktai
                </Trans>
            </h1>

            <div className={styles.contact_container}>
                <div className={`container ${styles.container}`}>
                    <ControlPanelBackground className={styles.left_shape} />
                    <div className="row">
                        <div
                            className={`offset-lg-1 offset-xl-2 col-lg-5 col-xl-4 ${styles.text}`}
                        >
                            <h2>UAB "Esnet"</h2>
                            <p>
                                <Trans
                                    i18nKey="contact.text.first"
                                    ns="landingInformationAboutCompany"
                                >
                                    Įmonės kodas: 302482484
                                    <br />
                                    PVM kodas: LT100007300313
                                    <br />
                                    Žuvėdrų g. 36, Vilnius, LT-10103, Lietuva
                                    <br />
                                </Trans>
                            </p>

                            <p>
                                <Trans
                                    i18nKey="contact.text.second"
                                    ns="landingInformationAboutCompany"
                                >
                                    Bankas: AB "Swedbank"
                                    <br />
                                    Banko sąskaita: LT277300010121039274
                                    <br />
                                    Banko kodas: 73000
                                    <br />
                                    SWIFT: HABALT22
                                    <br />
                                </Trans>
                            </p>
                            <button
                                type="button"
                                className={`btn btn-primary btn-lg ${styles.btn}`}
                                onClick={() => {
                                    document
                                        .getElementById('contact-form')
                                        ?.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'center',
                                            inline: 'center',
                                        });
                                }}
                            >
                                <Trans
                                    i18nKey="contact.button"
                                    ns="landingInformationAboutCompany"
                                >
                                    Susisiekite su mumis
                                </Trans>
                            </button>
                        </div>
                        <div className={`col-sm-12 col-lg-6 ${styles.options}`}>
                            <div className={styles.inner}>
                                <a href="tel:+37067174997">
                                    <span>
                                        <img src="/static/img/icons/phone.svg" />
                                        +370 671 74997
                                    </span>
                                </a>
                            </div>
                            <div className={styles.inner}>
                                <a href="mailto:info@vpsnet.com">
                                    <span>
                                        <img src="/static/img/icons/email.svg" />
                                        info@vpsnet.com
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <ControlPanelBackground className={styles.right_shape} />
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
